import { ActivatedRoute } from '@angular/router';

export abstract class ParamRetrieverUtils {
  /**
   * Retrieves the value of a parameter from the current route or any of its parent routes.
   *
   * @param {string} paramName - The name of the parameter to retrieve.
   * @param {ActivatedRoute} route - The current Angular route from which to start searching for the parameter.
   * @return {string | undefined} The value of the specified parameter if found, otherwise undefined.
   */
  static getParamFromParents(paramName: string, route: ActivatedRoute): string | undefined {
    let currentRoute: ActivatedRoute | null = route;
    while (currentRoute) {
      if (currentRoute.snapshot.paramMap.has(paramName)) {
        return currentRoute.snapshot.paramMap.get(paramName) || undefined;
      }
      currentRoute = currentRoute.parent;
    }
    return undefined;
  }
}
